import axios from "axios"
import "@/utils/http-tracking"
import { clearSession, store } from '../store'
import Vue from 'vue'

const CancelToken = axios.CancelToken;
export let requestCancelSource = CancelToken.source();

export const generateAxiosCancelToken = () => {
    requestCancelSource = CancelToken.source()
}

export const Service = {
    $http: axios.create({
        headers: { "Content-Type": "application/json" },
    })
}

Service.$http.interceptors.request.use(config => {
    if (store && store.token)
        config.headers.Authorization = "Bearer " + store.token
        config.cancelToken = requestCancelSource.token
    return config
});

Service.$http.interceptors.response.use(
    response => {
        return Promise.resolve(response)
    },
    error => {
        if (error.response && error.response.data && error.response.data.type == 'AUTH') {
            clearSession()
            if (Vue.router && Vue.router.currentRoute.path !== '/')
                Vue.router.push('/')
        }
        return Promise.reject(error)
    });

export const optionsHeadersContentMultipart = {
    headers: {
        "Content-Type": "multipart/form-data",
    },
};
